// src/api/navbarApi.js
import { navbarMockData } from "./mock/navbarData";

export const getNavbarData = () => {
  return new Promise((resolve) => {
    // Simulasi delay API selama 500ms
    setTimeout(() => {
      resolve(navbarMockData);
    }, 500);
  });
};